/*
 * @Author       : yilei
 * @Date         : 2023-01-31 17:38:16
 * @LastEditTime : 2023-02-10 11:00:31
 * @LastEditors  : yilei
 */
import React from 'react'
import { Divider, Layout, Space } from 'antd'
import clsx from 'clsx'
import styles from './footer.module.less'

const linkList: any[] = [
  { title: '关于我们', link: '//kfzx.anjuke.com/faqList/faqList?faqTypeId=8', target: '_blank' },
  { title: '用户协议', link: '//m.anjuke.com/feuser/richcontent/agreement?id=129', target: '_blank' },
  { title: '隐私政策', link: '//m.anjuke.com/feuser/richcontent/agreement?id=130', target: '_blank' },
  { title: '营业执照', link: '//h5.anjuke.com/broker/policy/store-vip-qualifications-licence-new', target: '_blank' },
  { title: '联系邮箱 service@58.com', link: 'javascript: void(0);', className: styles['no-link'] },
  { title: '虚假信息举报 400-620-9008', link: 'javascript: void(0);', className: styles['no-link'] },
  { title: '查看IP地址', link: '//vip.anjuke.com/ip', target: '_blank' }
]

const renderLinkItem = (item: any, index: number) => {
  return item.target && item.link
    ? <a key={index} href={item.link} target="_blank" rel="noreferrer" className={item.className}>{item.title}</a>
    : <a key={index} className={item.className}>{item.title}</a>
}

const currentYear = new Date().getFullYear()

const MetisFooter = () => {
  return (
    <Layout.Footer className={clsx(styles.footer, styles['is-new'])}>
      <div className={styles['footer-link']}>
        <Space className={styles['space-split']} split={<Divider type="vertical" />}>
          {linkList.map((item, index) => {
            return renderLinkItem(item, index)
          })}
        </Space>
      </div>
      <div className={styles['footer-right']}>
        <Space className={styles['space-split']} split={<Divider type="vertical" />}>
          <span>
            Copyright © 2007-{currentYear} {'www.anjuke.com'} All Rights Reserved
          </span>
          <a href="//beian.miit.gov.cn" target="_blank" rel="noreferrer">ICP号：沪B2-20090008-1</a>
        </Space>
      </div>
    </Layout.Footer>
  )
}

export { MetisFooter as NewMetisFooter }
